import React from "react";
import { formatDate, formatTime } from "../components/common/timestampFormat";
import { toTitleCase } from "../util/titleCase";

const NewNotes = ({ fetchedNotes }) => {
  return (
    <>
      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 col-gap-8 justify-center ml-12 sm:ml-0 px-3 sm:px-2'>
        {fetchedNotes.map((note) => (
          <div key={note.idx} className=''>
            <div className='inset-0 z-1 rounded-l-md rounded-r-none border border-blue-200 mt-2 mb-4 bg-blue-800 relative newHomework mr-4'>
              <div className='bg-white newHomework p-4 text-gray-100 -mt-3 -ml-3 inset-0 absolute newNotesShadow mr-4'>
                {/* <div className="flex justify-between items-center mb-4">
                                <span> {note.class} </span>
                                <span className="w-3 h-3 bg-green-100 rounded-full" />
                            </div> */}
                <div className='block mx-auto text-center newHomeworkPositioning'>
                  <div className='flex justify-center mx-auto font-semibold text-gray-100 text-base'>
                    {toTitleCase(
                      note.subjectname ||
                        note.subject_idx ||
                        note.subject ||
                        "Note"
                    )}
                  </div>
                  <div className='flex justify-center mx-auto font-semibold text-xs text-gray-300 mb-4'>
                    {note.subtopic ||
                      note.topic ||
                      note.new_topic ||
                      note.topicname ||
                      "No Topic"}
                  </div>
                  <div className='flex flex-col justify-center newHomeworkDate text-xs text-gray-500 px-2 leading-3 mb-4'>
                    <span className='flex justify-center'>
                      {" "}
                      {formatDate(
                        note.timestp || note.created_at || note.dater
                      )}{" "}
                    </span>
                    <span className='flex justify-center mt-1'>
                      {" "}
                      {formatTime(
                        note.timestp || note.created_at || note.dater
                      )}{" "}
                    </span>
                  </div>
                  <div className='flex justify-center items-center cursor-pointer p-2 mb-2 text-xs font-medium rounded border border-gray-500 newHomeworkView'>
                    <a
                      href={
                        note.downloadURL ||
                        note.download_url ||
                        note.file_path ||
                        note.filepath
                      }
                      target='_blank'
                      className='mr-2'>
                      {" "}
                      Download{" "}
                    </a>
                    <svg
                      width='12'
                      height='13'
                      viewBox='0 0 12 13'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'>
                      <path
                        fill-rule='evenodd'
                        clip-rule='evenodd'
                        d='M1.33317 11.6667H10.6665C10.8433 11.6667 11.0129 11.7369 11.1379 11.862C11.2629 11.987 11.3332 12.1566 11.3332 12.3334C11.3332 12.5102 11.2629 12.6798 11.1379 12.8048C11.0129 12.9298 10.8433 13 10.6665 13H1.33317C1.15636 13 0.98679 12.9298 0.861766 12.8048C0.736742 12.6798 0.666504 12.5102 0.666504 12.3334C0.666504 12.1566 0.736742 11.987 0.861766 11.862C0.98679 11.7369 1.15636 11.6667 1.33317 11.6667ZM6.6665 7.78338L8.8285 5.62204L9.77117 6.56471L5.99984 10.336L2.2285 6.56471L3.17117 5.62204L5.33317 7.78338V0.333374H6.6665V7.78338Z'
                        fill='#000114'
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default NewNotes;
